var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileOutlinedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1C0 0.447715 0.447715 0 1 0H7.49988C7.76509 0 8.01945 0.105357 8.20698 0.292893L15.707 7.79289C15.8945 7.98043 15.9999 8.23478 15.9999 8.5V19C15.9999 19.2652 15.8945 19.5196 15.707 19.7071C15.5194 19.8946 15.2651 20 14.9999 20L0.999998 20C0.447714 20 0 19.5523 0 19V1ZM2 2V18L13.9999 18V9.5H7.49988C6.94759 9.5 6.49988 9.05229 6.49988 8.5V2H2ZM8.49988 3.41421L12.5857 7.5H8.49988V3.41421Z",
    fill: "#02C3CD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileOutlinedIcon);
export default __webpack_public_path__ + "static/media/FileOutlinedIcon.47f5f6fe8cb5e2e6a0fd8c2d69f35fdc.svg";
export { ForwardRef as ReactComponent };